import React from 'react';
import axios from 'axios';

export default class PostUser extends React.Component {
  state = {
    name: '',
    persons: []
  }

  handleChange = event => {
    this.setState({ name: event.target.value });
  }

  handleSubmit = event => {
    event.preventDefault();

    const user = {
      name: this.state.name
    };

    axios.post(`https://jsonplaceholder.typicode.com/users`, { user })
      .then(res => {
        console.log(res);
        console.log(res.data);
        this.setState({user: res.data})
      })
  }

update = (e) => {
    e.preventDefault();
    const user = {
        name: this.state.name
      };
    axios.put(`https://jsonplaceholder.typicode.com/users/${this.state.id}`, user)
    .then(res => console.log(res.data));
}

  componentDidMount() {
    axios.get(`https://jsonplaceholder.typicode.com/users`)
      .then(res => {
        const persons = res.data.slice(0,4);
        this.setState({ persons });
      })
  }

  render() {
    //   const {name, persons} = this.state
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <label>
            Person Name:
            <input type="text" name="name" onChange={this.handleChange} />
          </label>
          <button type="submit">Add</button>
        </form>
        <ul>
        { this.state.persons.map(person => <li 
        key={person.id}
        onClick={this.update}>{person.name}</li>)}
      </ul>
        
        {/* <div className="ui  middle aligned selection relaxed divided list">
          {persons.map(person => (
            <div key={person.id} className="item">
                <i className="large github middle aligned icon"></i>
                <div className="content">
                  <span>
                  <p className="header">
                  {person.name}
                  </p>
                  <div className="description">
                  Email: {person.email}
                  </div>
                  </span>
                </div>
            </div>
          ))}
        </div> */}
      </div>
    )
  }
}